import { FC, useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { Style } from '@capacitor/status-bar';
import { Stack, SvgIcon } from '@mui/material';

import { VAR_AREA_TOP } from '@mopla/constants';
import { useTranslation } from '@mopla/i18';
import { MplButton, useStatusBarStyleSync } from '@mopla/ui';
import MailFilledIcon from '@mopla/ui/icons/MailFilledIcon.svg';

import { environment } from '../../../environments/environment';
import { SocialLogin } from '../../organisms/SocialLogin/SocialLogin';

import { WelcomeEntryCarousel } from './ui/WelcomeEntryCarousel';
import { PrivacyAndTermsRow } from './PrivacyAndTermsRow';
import { WelcomeEntryFooter, WelcomeEntryRoot } from './styled';

interface IWelcomeEntryProps {
	onEmailPasswordLoginClick: VoidFunction;
	onSignUpClick: VoidFunction;
}

const isNativePlatform = Capacitor.isNativePlatform();

export const WelcomeEntry: FC<IWelcomeEntryProps> = ({
	onEmailPasswordLoginClick,
	onSignUpClick,
}) => {
	const { t } = useTranslation('logIn');
	const { replace } = useStatusBarStyleSync();

	useEffect(() => {
		replace({
			title: 'NewHome',
			style: Style.Dark,
		});
	}, [replace]);

	return (
		<WelcomeEntryRoot elevation={isNativePlatform ? 0 : 2} square>
			<Stack
				sx={{
					marginTop: `calc(-1 * ${VAR_AREA_TOP})`,
					height: `calc(100% + ${VAR_AREA_TOP})`,
				}}
			>
				<WelcomeEntryCarousel />
				<WelcomeEntryFooter>
					<MplButton
						fullWidth
						color="primaryButtonV2"
						testId="welcomeScreen-login-button"
						startIcon={
							<SvgIcon
								fontSize="small"
								component={MailFilledIcon}
								inheritViewBox
							/>
						}
						onClick={onEmailPasswordLoginClick}
					>
						{t('button.emailPwdLogIn')}
					</MplButton>
					<SocialLogin
						isRegistration={false}
						socialLoginMethods={[...environment.allowedSocialLoginMethods]}
					/>
					<MplButton
						variant="text"
						testId="welcomeScreen-registration-button"
						onClick={onSignUpClick}
					>
						{t('button.newSignUp')}
					</MplButton>
					<PrivacyAndTermsRow mt={2} />
				</WelcomeEntryFooter>
			</Stack>
		</WelcomeEntryRoot>
	);
};
